import React from 'react';


import { PiWarningCircleThin } from "react-icons/pi";



function Error({ message, onRetry }) {
  return (
    <div className="error">
      {/* <div className="error-icon">⚠</div> */}
      <div className="error-icon-circle"><PiWarningCircleThin /></div>
      <h2 className="heading heading--h2">Unable to Load Quotes</h2>
      <p>{message}</p>
      <button onClick={onRetry} className="button button--secondary button--bordered">
        Try Again
      </button>
    </div>
  );
}

export default Error;
